const MAX_NOTE_LENGTH = 2000;

const NOTE_ACTION = {
  EDIT: 'EDIT',
  ADD: 'ADD',
  VIEW: 'VIEW',
};

const EXTENSION_TO_MIME = {
  pdf: 'application/pdf',

  jpeg: 'image/jpeg',
  jpg: 'image/jpg',
  png: 'image/png',
  gif: 'image/gif',
  doc: 'application/msword',
  heic: 'image/heic',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  csv: 'text/csv',
  txt: 'text/plain',
};

export { NOTE_ACTION, EXTENSION_TO_MIME, MAX_NOTE_LENGTH };
